import { createFileRoute, notFound } from '@tanstack/react-router';
import { ClassicGuidePageView } from '@/components/classic-guide/ClassicGuidePageView';
import { findClassicGuidePage } from '@/lib/classic-guide-content';

export const Route = createFileRoute('/classic-guide/$pageId')({
  loader: ({ params }) => {
    const page = findClassicGuidePage(params.pageId);
    if (!page) {
      throw notFound();
    }
    return { page };
  },
  component: ClassicGuidePageRoute,
});

function ClassicGuidePageRoute() {
  const { page } = Route.useLoaderData();
  return <ClassicGuidePageView page={page} />;
}
